// import React, { useEffect, useState } from 'react'
// import { Button, Flex, Flexed, Input, Label, Scroll, Selectbox, Textauto, Wrapper } from '../../../utilities/Shared'
// import axios from 'axios';
// import Collapse from '../../../utilities/Collapse';
// import Datetime from 'react-datetime';
// import { toast } from 'react-toastify';
// import { RiDeleteBack2Fill } from "react-icons/ri";
// import { colorchange } from '../../../utilities/Convertions';

// const moment = require("moment");
// const PrepressTicket = ({jobinfo,forms,reset,setReset,job}) => {





//   const[operations, setOperations] = useState([])
//   const[newforms, setnewForms] = useState([])
//   const[imposition, setImposition] = useState([])
//   const[proofstotal, setProofstotal] = useState({hours:0,minutes:0})
 




//   const[operationitems, setOperationitems] = useState([])
//   const[prepress, setPrespress] = useState([])
//   const[onprepresstimes, setOnprepresstimes] = useState({})
//   const[offprepresstimes, setOffprepresstimes] = useState({})

//   const[onplatingtimes, setOnplatingtimes] = useState({})
//   const[offplatingtimes, setOffplatingtimes] = useState({})
//   const[proofin, setProofin] = useState(false)
//   const[proofout, setProofout] = useState(false)
  
//   const [value, onChange] = useState(new Date());
//   const [onTimes, setOnTimes] = useState(null);
//   const [offTimes, setOffTimes] = useState(null);

  
//   const config = {
//     headers: {
//       'Content-Type': 'application/json',
//       'Access-Control-Allow-Origin':'*' 
//     }
//   };

//   useEffect(() => {

//     let r = {
//         job:job,
//     }
//     const getops = async() => {
//      await axios.post(`https://highgroundsoftware.com/dash/dashboard/php/getalloperations.php`,r,config)
//     .then(res => {setOperations(res.data);})
//     .catch(err => console.log(err))
//     }
//     const getquote = async() => {
//       let r = {
//         quote:jobinfo?.quote,
//       }
//       await axios.post(`https://highgroundsoftware.com/dash/dashboard/php/getimposition.php`,r,config)
//      .then(res => {setImposition(res.data);})
//      .catch(err => console.log(err))
//      }
//     getops()
//     getquote()
//   },[reset])

//   useEffect(() => {
//     setPrepressValues()
   
//   },[operations])



// const setPrepressValues = () => {

//   let imp
// let proofing = []
//   forms.map((item,index) => {
   
//     let pressins = []
//     let pressouts = []
//     let pressindis = []
//     let proofins = []
//     let proofouts = []
//     let proofindis = []
//     let plateins = []
//     let plateouts = []
//     let plateindis = []
//     let partofid  
//     let partof

//      imp = imposition?.filter(filter => filter.component === item.originalform)

//    operations?.filter(filter => filter.comp === item.name).map((op,index) => {
//     let diff = 0
//     if(op.name === "On Prepress"){pressins.push({id:op.id,time:op.changedon,status:"On Prepress"})}
//     if(op.name === "Off Prepress"){pressouts.push({id:op.id,time:op.changedon,status:"Off Prepress"})}  
//     if(op.name === "Incomplete Prepress"){pressouts.push({id:op.id,time:op.changedon,status:"Incomplete Prepress"})}
//     if(op.name === "AA Changes Prepress"){pressouts.push({id:op.id,time:op.changedon,status:"AA Changes Prepress"})} 
//     if(op.name === "PE Changes Prepress"){pressouts.push({id:op.id,time:op.changedon,status:"PE Changes Prepress"})}
//     if(op.name === "Prepress On Hold"){pressouts.push({id:op.id,time:op.changedon,status:"Prepress On Hold"})}

//     if(op.name === "On Proofing"){proofins.push({id:op.id,time:op.changedon,status:"On Proofing"})}
//     if(op.name === "Off Proofing"){proofouts.push({id:op.id,time:op.changedon,status:"Off Proofing"})}  
//     if(op.name === "Incomplete Proofing"){proofouts.push({id:op.id,time:op.changedon,status:"Incomplete Proofing"})}
//     if(op.name === "AA Changes Proofing"){proofouts.push({id:op.id,time:op.changedon,status:"AA Changes Proofing"})} 
//     if(op.name === "PE Changes Proofing"){proofouts.push({id:op.id,time:op.changedon,status:"PE Changes Proofing"})}
//     if(op.name === "Proofing On Hold"){proofouts.push({id:op.id,time:op.changedon,status:"Proofing On Hold"})}

//     if(op.name === "On Plating"){plateins.push({id:op.id,time:op.changedon,status:"On Plating"})}
//     if(op.name === "Off Plating"){plateouts.push({id:op.id,time:op.changedon,status:"Off Plating"})}  
//     if(op.name === "Incomplete Plating"){plateouts.push({id:op.id,time:op.changedon,status:"Incomplete Plating"})}
//     if(op.name === "AA Changes Plating"){plateouts.push({id:op.id,time:op.changedon,status:"AA Changes Plating"})} 
//     if(op.name === "PE Changes Plating"){plateouts.push({id:op.id,time:op.changedon,status:"PE Changes Plating"})}
//     if(op.name === "Plating On Hold"){plateouts.push({id:op.id,time:op.changedon,status:"Plating On Hold"})}
    
//     })

   
//    pressindis=(getdiff(pressins,pressouts))
//    proofindis=(getdiff(proofins,proofouts))
//    plateindis=(getdiff(plateins,plateouts))
   


//     const y = {
//       id:item.id,
//       item:item.item,
//         name:item.name,
//         formid:item.formid,
//         partofid:item.partofid, 
//         partof:item.item,
//         processtext:item.processtext,
//         prepress:
//           {'ins':pressins,
//             'out':pressouts,
//             'indiv':pressindis,
//             'estimatedtime':setesttime(imp,'prepress'),
          
//     },
//     proofing:
//       {'ins':proofins,
//         'out':proofouts,
//         'indiv':proofindis,
//         'estimatedtime':setesttime(imp,'proofing'),
      
// },
// plating:
//   {'ins':plateins,
//     'out':plateouts,
//     'indiv':plateindis,
//     'estimatedtime':setesttime(imp,'plating'),
  
// }
//     }
//     proofing.push(y)
// })

// setnewForms(proofing)
// }






// const getdiff = (inTimes,outTimes) => {

// let tot =[]
// let u


// inTimes?.map((item,index) => {

//       let time
//         let intime = new Date(item?.time)
//         let outtime = new Date(outTimes[index]?.time)
//      time = Math.abs(outtime - intime)


   
//   let y =timeConvert(time/1000/60)
//   if(isNaN(y.hours)){y.hours = 0}
//   if(isNaN(y.minutes)){y.minutes = 0}
//    u = {hours:y.hours,minutes:y.minutes}
//   tot.push(u)
// })
// return(tot)
// }

// const setesttime = (imp,item) => {
//   let newitem

// switch(item){
// case "prepress":
//   if(parseInt(imp[0]?.numforms) > 1){
//       let r = parseFloat(imp[0]?.presstime1) + parseFloat(imp[0]?.presstime2)
   
//       newitem = (r / parseInt(imp[0]?.numforms))
//   } 
// break;
// case "proofing":
//   if(parseInt(imp[0]?.numforms) > 1){
//       let r = parseFloat(imp[0]?.presstime1) + parseFloat(imp[0]?.presstime2)
     
//       newitem = (r / parseInt(imp[0]?.numforms))
//   } 
// break;
// case "plating":
//   if(parseInt(imp[0]?.numforms) > 1){
//       let r = parseFloat(imp[0]?.presstime1) + parseFloat(imp[0]?.presstime2)
 
//       newitem = (r / parseInt(imp[0]?.numforms))
//   } 
// break;
// }

// let y = converttime(newitem)
// return y
// }



// function timeConvert(n) { 
   
//   var num = n;
//   var hours = (num / 60);
//   var rhours = Math.floor(hours);
//   var minutes = (hours - rhours) * 60;
//   var rminutes = Math.round(minutes);
  
//  // if(isNaN(rhours)){rhours = 0}
//   //if(isNaN(rminutes)){rminutes = 0}
//   let t = {hours:proofstotal.hours + rhours,minutes:proofstotal.minutes + rminutes}

//   return{hours:rhours,minutes:rminutes}
//   } 

//   const converttime = (item) => {

//     let hours = 0
//         let minutes = 0
//         let myArray = []
//     if(item !== undefined){
//          myArray = item.toString()?.split(".");
//        hours = parseInt(myArray[0])
//        minutes = parseInt(myArray[1])

//         let check = minutes/100
//         if(check > 1){
//          minutes = minutes % 100
       
//         }
//     }
//    return({hours,minutes})
// }


// const getDiff = (intime,outtime,item) => {
//    intime = new Date(intime)
//    outtime = new Date(outtime)
//      let  time = Math.abs(outtime - intime)

//      let y = (timeConvert(time/1000/60))


//      return `${y.hours}:${y.minutes}`
// }







// const setchangevalues = (item) => {
   
//   let d
//   let s
//   let p
//   let push
// switch(item){
//   case "On Prepress":
// d = 0
// s = 1
// p = 2
// push=0
// break;
//  case "On Awaiting Files":
// d = 0
// s = 1
// p = 2
// push=0
// break;
// case "Off Prepress":
// d = 0
// s = 0
// p = 2
// push=0
// break;
// case "Off Awaiting Files":
// d = 0
// s = 1
// p = 2
// push=0
// break;
// case "Incomplete Prepress":
// d = 0
// s = 0
// p = 2
// push=0
// break;
// case "On Proofing":
// d = 0
// s = 1
// p = 2
// push=0
// break;
// case "Off Proofing":
// d = 0
// s = 0
// p = 2
// push=0
// break;
// case "Incomplete Proofing":
// d = 0
// s = 0
// p = 2
// push=0
// break;
// case "On Plating":
//   d = 1
//   s = 1
//   p = 3
//   push=0
//   break;
//   case "Off Plating":
//   d = 1
//   s = 0
//   p = 3
//   push=0
//   break;
//   case "Incomplete Plating":
//   d = 1
//   s = 0
//   p = 3
//   push=0
//   break;
//   case "AA Changes Plating":
// d = 1
// s = 0
// p = 3
// push=0
// break;
// case "PE Changes Plating":
// d = 1
// s = 0
// p = 2
// push=0
// break;
// case "AA Changes Prepress":
// d = 0
// s = 0
// p = 2
// push=0
// break;
// case "PE Changes Prepress":
// d = 0
// s = 0
// p = 2
// push=0
// break;
// case "AA Changes Proofing":
// d = 0
// s = 0
// p = 2
// push=0
// break;
// case "PE Changes Proofing":
// d = 0
// s = 0
// p = 2
// push=0
// break;
// case "Prepress On Hold":
// d = 0
// s = 1
// p = 0
// push=0
// break;
// case "Plating On Hold":
// d = 0
// s = 1
// p = 0
// push=0
// break;
// case "Proofing On Hold":
// d = 0
// s = 1
// p = 0
// push=0
// break;
// }
// return {d,s,p,push}
// }


// const setpushes = (e,form) => {

// let set = {}
//   if(e.target.value === "Off Proofing"){
// switch(form.processtext){
// case "Digital":
//   set.name = "Ready Digital";
//   set.dept = 2
//   break;
//   case "Colormax":
//   set.name = "Ready Colormax";
//   set.dept = 2
//   break;
//   default:
//     set.name = "Ready Plating"
//     set.dept = 1
//     break;
// }            
// set.push = 1
// set.process=3
//   }
//   if(e.target.value === "Off Plating"){
//     set.dept = 3
//     set.push = 0
//     set.name = "Plated"
//     set.process=0
//       }
//   const z = {
//     job:job,
//     item:form.item,
//     partof:form.partof,
//     partofid:form.partofid,
//     process:set.process,
//     comp:form.name,
//     changedby:sessionStorage.getItem('eid'),
//   name:set.name,
//   dept:set.dept,
//   status:0,
//   push:set.push
//   }

//   const savit = async() => {
//     await axios.post(`https://highgroundsoftware.com/dash/dashboard/php/addoperation.php`,z,config)
//     .then(res => {toast.success('Process Saved');setReset(!reset)} )
//     .catch(err => toast.error('Something went wrong and process was not saved') )

 
//   }

  
//   savit()
// }


// const changestatus = (e,form,index) => {

// let values = setchangevalues(e.target.value)

// const z = {
//   job:job,
//   item:form.item,
//   partof:form.partof,
//   partofid:form.partofid,
//   process:values.p,
// 	comp:form.name,
// 	changedby:sessionStorage.getItem('eid'),
// name:e.target.value,
// dept:values.d,
// status:values.s,
// push:values.push
// }


// const savit = async() => {
//   await axios.post(`https://highgroundsoftware.com/dash/dashboard/php/addoperation.php`,z,config)
//   .then(res => {setpushes(e,form)} )
//   .catch(err => toast.error('Something went wrong and process was not saved') )

//   let r = {job,component:form?.name,status:e.target.value}
//  await axios.post('https://highgroundapi.herokuapp.com/sched/gl40/updatestatus',r)
//   //await axios.post('http://localhost:5001/sched/gl40/updatestatus',r)
//   .then(res => console.log(res.data))
//   .catch(err => console.log(err))
// }


// savit()
// }







// const changetime = (e,form) => {

//   const z = {
//     changedon:e.target.value,
// id:form.id 
//   }
  
//   const savit = async() => {
//     await axios.post(`https://highgroundsoftware.com/dash/dashboard/php/updateoperation.php`,z,config)
//     .then(res => {setReset(!reset)} )
//     .catch(err => toast.error('Something went wrong and process was not saved') )
//   }
//  savit()
// }


//   return (
//     <Wrapper style={{height:"70vh",position:"relative",color:"black"}}>
    
  
//     <Scroll height="100%">
// {/*
// /////////////////////////////////////////////////////////////////////////////////////////////////////////Pre-Press
// */}
//     <div style={{border:"1px solid black",padding:"10px"}}>  
//     <Flexed>
// <Flex fontSize="calc(1.3rem + .2vw)" fontWeight="bold" style={{textDecoration:"underline"}} padding="5px" bgColor="var(--plsBlue)" color="white"> Pre-Press</Flex>
//    </Flexed>
//    <Flexed padding="5px 0px 10px 0px">
// <Flex style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)">Form:</Flex>
// <Flex flex="4">
//       <Flexed>
// <Flex style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)" minWidth="20%">Start:</Flex>
// <Flex style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)" minWidth="20%">Finish / Incomplete:</Flex>

// <Flex flex=".5" style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)" >Actual:</Flex>

// </Flexed>

//     </Flex>
//     <Flex flex=".5" style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)" >Estimated:</Flex>
//     <Flex style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)" >Status Change</Flex>
//    </Flexed>

//     {newforms.map((form,index) => {
//       return <> <Flexed padding="4px 0px" borderBottom="1px solid grey" margin="0px 0px 15px 0px">
//         <Flex fontSize="calc(.9rem + .2vw)" top="8px">{form.name}</Flex>
//         <Flex flex="4">
//           {form.prepress.ins?.map((ite,index) => {
//  return <Flexed padding="4px 0px">
//  <Flex  minWidth="20%"><input onChange={e => changetime(e,ite)} style={{fontSize:"calc(1rem + .2vw)",width:"90%",background:colorchange(ite.status)}} type="datetime-local" value={ite.time}/></Flex>
//  <Flex  minWidth="20%">{form.prepress.out[index] && <><RiDeleteBack2Fill style={{fontSize:"calc(1.1rem + .2vw)",position:"relative",top:"2.5px"}}/> <input onChange={e => changetime(e,form.prepress.out[index])} style={{fontSize:"calc(1rem + .2vw)",width:"90%",background:colorchange(form.prepress.out[index].status)}} type="datetime-local" value={form.prepress.out[index].time}/></>}</Flex>
//  <Flex flex=".5" fontSize="calc(1.2rem + .2vw)">{form.prepress.indiv[index].hours}:{form.prepress.indiv[index].minutes}</Flex>
//  </Flexed>
//           })}
//             </Flex>
//             <Flex flex=".5" fontSize="calc(1.2rem + .2vw)" style={{position:"relative",top:"2.5px"}}>{form.prepress.estimatedtime.hours}:{form.prepress.estimatedtime.minutes}</Flex>
//             <Flex style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)" >
//  <Selectbox onChange={e => changestatus(e,form,index)} style={{padding:'3px 0px'}}>
//  <option value="" selected >Select Status</option>
//  <optgroup label="On Status">
//  <option value="On Prepress">On Prepress</option>
//  <option value="On Awaiting Files">On Awaiting Files</option>
//  </optgroup>
//  <optgroup label="Off Status">
//  <option value="Off Prepress">Off Prepress</option>
//   <option value="Off Awaiting Files">Off Awaiting Files</option>
//  </optgroup>
//  <optgroup label="Changes">
   
//  <option value="Incomplete Prepress">Incomplete Prepress</option>
//  <option value="AA Changes Prepress">AA Changes</option>
//  <option value="PE Changes Prepress">PE Changes</option>
//  <option value="Prepress On Hold">Prepress On Hold</option>
//  </optgroup>
//  </Selectbox>
//  </Flex>
//            </Flexed>
      
//              <Flexed borderBottom="1px solid grey"><Flex>{form.digital ? 'Toner' : 'Inks'} Used: <Input /> </Flex><Flex>Stock Used: <Input /> </Flex><Flex flex="5">Notes:<br /><Textauto minHeight="25px"/></Flex></Flexed><br />
//            </>
//     }) 
//   }
// </div>

// {/*
// /////////////////////////////////////////////////////////////////////////////////////////////////////////Proofing
// */}

// <div style={{border:"1px solid black",padding:"10px"}}>  
//     <Flexed>
// <Flex fontSize="calc(1.3rem + .2vw)" fontWeight="bold" style={{textDecoration:"underline"}} padding="5px" bgColor="var(--plsBlue)" color="white"> Proofing</Flex>
//    </Flexed>
//    <Flexed padding="5px 0px 10px 0px">
// <Flex style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)">Form:</Flex>
// <Flex flex="4">
//       <Flexed>
// <Flex style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)" minWidth="20%">Start:</Flex>
// <Flex style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)" minWidth="20%">Finish / Incomplete:</Flex>

// <Flex flex=".5" style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)" >Actual:</Flex>

// </Flexed>

//     </Flex>
//     <Flex flex=".5" style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)" >Estimated:</Flex>
//     <Flex style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)" >Status Change</Flex>
//    </Flexed>

//     {newforms.map((form,index) => {
//       return <> <Flexed padding="4px 0px" borderBottom="1px solid grey" margin="0px 0px 15px 0px">
//         <Flex fontSize="calc(.9rem + .2vw)" top="8px">{form.name}</Flex>
//         <Flex flex="4">
//           {form.proofing.ins?.map((ite,index) => {
//  return <Flexed padding="4px 0px">
//  <Flex  minWidth="20%"><input onChange={e => changetime(e,ite)} style={{fontSize:"calc(1rem + .2vw)",width:"90%",background:colorchange(ite.status)}} type="datetime-local" value={ite.time}/></Flex>
//  <Flex  minWidth="20%">{form.proofing.out[index] && <><RiDeleteBack2Fill style={{fontSize:"calc(1.1rem + .2vw)",position:"relative",top:"2.5px"}}/> <input onChange={e => changetime(e,form.proofing.out[index])} style={{fontSize:"calc(1rem + .2vw)",width:"90%",background:colorchange(form.proofing.out[index].status)}} type="datetime-local" value={form.proofing.out[index].time}/></>}</Flex>
//  <Flex flex=".5" fontSize="calc(1.2rem + .2vw)">{form.proofing.indiv[index].hours}:{form.proofing.indiv[index].minutes}</Flex>
//  </Flexed>
//           })}
//             </Flex>
//             <Flex flex=".5" fontSize="calc(1.2rem + .2vw)" style={{position:"relative",top:"2.5px"}}>{form.proofing.estimatedtime.hours}:{form.proofing.estimatedtime.minutes}</Flex>
//             <Flex style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)" >
//  <Selectbox onChange={e => changestatus(e,form,index)}  style={{padding:'3px 0px'}}>
//  <option value="" selected >Select Status</option>
//  <optgroup label="On Status">
//  <option value="On Proofing">On Proofing</option>
//  </optgroup>
//  <optgroup label="Off Status">
//  <option value="Off Proofing">Off Proofing</option>
//  </optgroup>
//  <optgroup label="Changes">
//  <option value="Incomplete Proofing">Incomplete Proofing</option>
//  <option value="AA Changes Proofing">AA Changes Proofing</option>
//  <option value="PE Changes Proofing">PE Changes Proofing</option>
//  <option value="Proofing On Hold">Proofing On Hold</option>
//  </optgroup>
//  </Selectbox>
//  </Flex>
//            </Flexed>
      
//              <Flexed borderBottom="1px solid grey"><Flex>{form.digital ? 'Toner' : 'Inks'} Used: <Input /> </Flex><Flex>Stock Used: <Input /> </Flex><Flex flex="5">Notes:<br /><Textauto minHeight="25px"/></Flex></Flexed><br />
//            </>
//     }) 
//   }
// </div>

// {/*
// /////////////////////////////////////////////////////////////////////////////////////////////////////////Proofing
// */}

// <div style={{border:"1px solid black",padding:"10px"}}>  
//     <Flexed>
// <Flex fontSize="calc(1.3rem + .2vw)" fontWeight="bold" style={{textDecoration:"underline"}} padding="5px" bgColor="var(--plsBlue)" color="white"> Plating</Flex>
//    </Flexed>
//    <Flexed padding="5px 0px 10px 0px">
// <Flex style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)">Form:</Flex>
// <Flex flex="4">
//       <Flexed>
// <Flex style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)" minWidth="20%">Start:</Flex>
// <Flex style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)" minWidth="20%">Finish / Incomplete:</Flex>

// <Flex flex=".5" style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)" >Actual:</Flex>

// </Flexed>

//     </Flex>
//     <Flex flex=".5" style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)" >Estimated:</Flex>
//     <Flex style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)" >Status Change</Flex>
//    </Flexed>

//     {newforms.map((form,index) => {
//       return <> <Flexed padding="4px 0px" borderBottom="1px solid grey" margin="0px 0px 15px 0px">
//         <Flex fontSize="calc(.9rem + .2vw)" top="8px">{form.name}</Flex>
//         <Flex flex="4">
//           {form.plating.ins?.map((ite,index) => {
//  return <Flexed padding="4px 0px">
//  <Flex  minWidth="20%"><input onChange={e => changetime(e,ite)} style={{fontSize:"calc(1rem + .2vw)",width:"90%",background:colorchange(ite.status)}} type="datetime-local" value={ite.time}/></Flex>
//  <Flex  minWidth="20%">{form.plating.out[index] && <><RiDeleteBack2Fill style={{fontSize:"calc(1.1rem + .2vw)",position:"relative",top:"2.5px"}}/> <input onChange={e => changetime(e,form.plating.out[index])} style={{fontSize:"calc(1rem + .2vw)",width:"90%",background:colorchange(form.plating.out[index].status)}} type="datetime-local" value={form.plating.out[index].time}/></>}</Flex>
//  <Flex flex=".5" fontSize="calc(1.2rem + .2vw)">{form.plating.indiv[index].hours}:{form.plating.indiv[index].minutes}</Flex>
//  </Flexed>
//           })}
//             </Flex>
//             <Flex flex=".5" fontSize="calc(1.2rem + .2vw)" style={{position:"relative",top:"2.5px"}}>{form.plating.estimatedtime.hours}:{form.plating.estimatedtime.minutes}</Flex>
//             <Flex style={{textDecoration:"underline"}} fontSize="calc(1.1rem + .2vw)" >
//  <Selectbox onChange={e => changestatus(e,form,index)}  style={{padding:'3px 0px'}}>
//  <option value="" selected >Select Status</option>
//  <optgroup label="On Status">
//  <option value="On Plating">On Plating</option>
//  </optgroup>
//  <optgroup label="Off Status">
//  <option value="Off Plating">Off Plating</option>
//  </optgroup>
//  <optgroup label="Changes">
//  <option value="Incomplete Plating">Incomplete Plating</option>
//  <option value="AA Changes Plating">AA Changes Plating</option>
//  <option value="PE Changes Plating">PE Changes Plating</option>
//  <option value="Plating On Hold">Plating On Hold</option>
//  </optgroup>
//  </Selectbox>
//  </Flex>
//            </Flexed>
      
//              <Flexed borderBottom="1px solid grey"><Flex>{form.digital ? 'Toner' : 'Inks'} Used: <Input /> </Flex><Flex>Stock Used: <Input /> </Flex><Flex flex="5">Notes:<br /><Textauto minHeight="25px"/></Flex></Flexed><br />
//            </>
//     }) 
//   }
// </div>
// <br /> <br /> <br /> <br />
//     </Scroll>
    

    
//     </Wrapper>
//   )
// }

// export default PrepressTicket




import React, { useEffect, useState } from 'react';
import { Button, Flex, Flexed, Input, Label, Scroll, Selectbox, Textauto, Wrapper } from '../../../utilities/Shared';
import axios from 'axios';
import { toast } from 'react-toastify';
import { RiDeleteBack2Fill } from "react-icons/ri";
import { colorchange } from '../../../utilities/Convertions';

const moment = require("moment");

const PrepressTicket = ({ jobinfo, forms, reset, setReset, job }) => {
  const [operations, setOperations] = useState([]);
  const [newforms, setnewForms] = useState([]);
  const [imposition, setImposition] = useState([]);
  const [proofstotal, setProofstotal] = useState({ hours: 0, minutes: 0 });

  const [selectAllStatus, setSelectAllStatus] = useState({
    prepress: "",
    proofing: "",
    plating: ""
  });

  const config = { headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' } };

  // Fetch operations and imposition
  useEffect(() => {
    const r = { job };
    const getops = async () => {
      await axios.post(`https://highgroundsoftware.com/dash/dashboard/php/getalloperations.php`, r, config)
        .then(res => setOperations(res.data))
        .catch(err => console.log(err));
    };
    const getquote = async () => {
      const r = { quote: jobinfo?.quote };
      await axios.post(`https://highgroundsoftware.com/dash/dashboard/php/getimposition.php`, r, config)
        .then(res => setImposition(res.data))
        .catch(err => console.log(err));
    };
    getops();
    getquote();
  }, [reset]);

  useEffect(() => {
    setPrepressValues();
  }, [operations]);

  const setPrepressValues = () => {
    let proofing = [];
    forms.map((item) => {
      let pressins = [], pressouts = [], proofins = [], proofouts = [], plateins = [], plateouts = [];
      let pressindis = [], proofindis = [], plateindis = [];
      const imp = imposition?.filter(filter => filter.component === item.originalform);

      operations?.filter(filter => filter.comp === item.name).forEach((op) => {
        switch (op.name) {
          case "On Prepress": pressins.push({ id: op.id, time: op.changedon, status: "On Prepress" }); break;
          case "Off Prepress": case "Incomplete Prepress": case "AA Changes Prepress": case "PE Changes Prepress": case "Prepress On Hold":
            pressouts.push({ id: op.id, time: op.changedon, status: op.name }); break;
          case "On Proofing": proofins.push({ id: op.id, time: op.changedon, status: "On Proofing" }); break;
          case "Off Proofing": case "Incomplete Proofing": case "AA Changes Proofing": case "PE Changes Proofing": case "Proofing On Hold":
            proofouts.push({ id: op.id, time: op.changedon, status: op.name }); break;
          case "On Plating": plateins.push({ id: op.id, time: op.changedon, status: "On Plating" }); break;
          case "Off Plating": case "Incomplete Plating": case "AA Changes Plating": case "PE Changes Plating": case "Plating On Hold":
            plateouts.push({ id: op.id, time: op.changedon, status: op.name }); break;
          default: break;
        }
      });

      pressindis = getdiff(pressins, pressouts);
      proofindis = getdiff(proofins, proofouts);
      plateindis = getdiff(plateins, plateouts);

      proofing.push({
        id: item.id,
        item: item.item,
        name: item.name,
        formid: item.formid,
        partofid: item.partofid,
        partof: item.item,
        processtext: item.processtext,
        prepress: { ins: pressins, out: pressouts, indiv: pressindis, estimatedtime: setesttime(imp, 'prepress') },
        proofing: { ins: proofins, out: proofouts, indiv: proofindis, estimatedtime: setesttime(imp, 'proofing') },
        plating: { ins: plateins, out: plateouts, indiv: plateindis, estimatedtime: setesttime(imp, 'plating') },
        digital: item.digital
      });
    });
    setnewForms(proofing);
  };

  const getdiff = (inTimes, outTimes) => {
    let tot = [];
    inTimes?.forEach((item, index) => {
      let intime = new Date(item?.time);
      let outtime = new Date(outTimes[index]?.time);
      let time = Math.abs(outtime - intime);
      tot.push(timeConvert(time / 1000 / 60));
    });
    return tot;
  };

  function timeConvert(n) {
    let hours = Math.floor(n / 60);
    let minutes = Math.round(n % 60);
    return { hours, minutes };
  }

  const setesttime = (imp, item) => {
    if (!imp?.[0] || parseInt(imp[0]?.numforms) <= 1) return { hours: 0, minutes: 0 };
    let r = parseFloat(imp[0]?.presstime1) + parseFloat(imp[0]?.presstime2);
    let newitem = r / parseInt(imp[0]?.numforms);
    return converttime(newitem);
  };

  const converttime = (item) => {
    if (!item) return { hours: 0, minutes: 0 };
    const parts = item.toString().split(".");
    let hours = parseInt(parts[0]) || 0;
    let minutes = parseInt(parts[1]) || 0;
    if (minutes > 59) minutes = minutes % 100;
    return { hours, minutes };
  };

  const setchangevalues = (item) => {
    let d = 0, s = 0, p = 0, push = 0;
    switch (item) {
      case "On Prepress": case "On Awaiting Files": case "On Proofing": d = 0; s = 1; p = 2; break;
      case "Off Prepress": case "Off Awaiting Files": case "Off Proofing": case "Incomplete Prepress": case "Incomplete Proofing": case "Incomplete Plating": d = 0; s = 0; p = 2; break;
      case "On Plating": d = 1; s = 1; p = 3; break;
      case "Off Plating": d = 1; s = 0; p = 3; break;
      case "AA Changes Plating": case "PE Changes Plating": d = 1; s = 0; p = 3; break;
      case "AA Changes Prepress": case "PE Changes Prepress": case "AA Changes Proofing": case "PE Changes Proofing": d = 0; s = 0; p = 2; break;
      case "Prepress On Hold": case "Plating On Hold": case "Proofing On Hold": d = 0; s = 1; p = 0; break;
      default: break;
    }
    return { d, s, p, push };
  };

  const changestatus = (e, form) => {
    const values = setchangevalues(e.target.value);
    const z = {
      job, item: form.item, partof: form.partof, partofid: form.partofid,
      process: values.p, comp: form.name,
      changedby: sessionStorage.getItem('eid'), name: e.target.value, dept: values.d, status: values.s, push: values.push
    };

    axios.post(`https://highgroundsoftware.com/dash/dashboard/php/addoperation.php`, z, config)
      .then(() => { setReset(!reset); })
      .catch(() => toast.error('Something went wrong and process was not saved'));
  };

  // --- Select All Handler ---
  const handleSelectAll = (section, value) => {
    setSelectAllStatus(prev => ({ ...prev, [section]: value }));
    newforms.forEach(form => {
      changestatus({ target: { value } }, form);
    });
  };

  const changetime = (e, form) => {
    const z = { changedon: e.target.value, id: form.id };
    axios.post(`https://highgroundsoftware.com/dash/dashboard/php/updateoperation.php`, z, config)
      .then(() => setReset(!reset))
      .catch(() => toast.error('Something went wrong and process was not saved'));
  };

  // --- Render Section Function ---
  const renderSection = (sectionName, sectionKey, options) => (
    <div style={{ border: "1px solid black", padding: "10px" }}>
      <Flexed>
        <Flex fontSize="calc(1.3rem + .2vw)" fontWeight="bold" style={{ textDecoration: "underline" }} padding="5px" bgColor="var(--plsBlue)" color="white">
          {sectionName}
        </Flex>
      </Flexed>

      {/* Select All Dropdown */}
      <Flexed padding="5px 0px 10px 0px">
        <Flex>Select All:</Flex>
        <Flex style={{display:'flex',justifyContent:"flex-end"}}>
          <Selectbox value={selectAllStatus[sectionKey]} onChange={(e) => handleSelectAll(sectionKey, e.target.value)} style={{padding:'5px 0px',width:'38%'}}>
            <option value="">Select All</option>
            {options.map(opt => <option key={opt} value={opt}>{opt}</option>)}
          </Selectbox>
        </Flex>
      </Flexed>

      {newforms.map((form, index) => (
        <Flexed key={index} padding="4px 0px" borderBottom="1px solid grey" margin="0px 0px 15px 0px">
          <Flex fontSize="calc(.9rem + .2vw)" top="8px">{form.name}</Flex>
          <Flex flex="4">
            {form[sectionKey]?.ins?.map((ite, i) => (
              <Flexed key={i} padding="4px 0px">
                <Flex minWidth="20%">
                  <input onChange={e => changetime(e, ite)} style={{ fontSize: "calc(1rem + .2vw)", width: "90%", background: colorchange(ite.status) }} type="datetime-local" value={ite.time} />
                </Flex>
                <Flex minWidth="20%">
                  {form[sectionKey].out[i] &&
                    <>
                      <RiDeleteBack2Fill style={{ fontSize: "calc(1.1rem + .2vw)", position: "relative", top: "2.5px" }} />
                      <input onChange={e => changetime(e, form[sectionKey].out[i])} style={{ fontSize: "calc(1rem + .2vw)", width: "90%", background: colorchange(form[sectionKey].out[i].status) }} type="datetime-local" value={form[sectionKey].out[i].time} />
                    </>}
                </Flex>
                <Flex flex=".5" fontSize="calc(1.2rem + .2vw)">{form[sectionKey].indiv[i].hours}:{form[sectionKey].indiv[i].minutes}</Flex>
              </Flexed>
            ))}
          </Flex>
          <Flex flex=".5" fontSize="calc(1.2rem + .2vw)" style={{ position: "relative", top: "2.5px" }}>{form[sectionKey].estimatedtime.hours}:{form[sectionKey].estimatedtime.minutes}</Flex>
          <Flex style={{ textDecoration: "underline" }} fontSize="calc(1.1rem + .2vw)">
            <Selectbox onChange={e => changestatus(e, form)} style={{padding:'5px 0px'}}>
              <option value="">Select Status</option>
              {options.map(opt => <option key={opt} value={opt}>{opt}</option>)}
            </Selectbox>
          </Flex>
        </Flexed>
      ))}
    </div>
  );

  return (
    <Wrapper style={{ height: "70vh", position: "relative", color: "black" }}>
      <Scroll height="100%">
        {renderSection("Pre-Press", "prepress", ["On Prepress", "On Awaiting Files", "Off Prepress", "Off Awaiting Files", "Incomplete Prepress", "AA Changes Prepress", "PE Changes Prepress", "Prepress On Hold"])}
        {renderSection("Proofing", "proofing", ["On Proofing", "Off Proofing", "Incomplete Proofing", "AA Changes Proofing", "PE Changes Proofing", "Proofing On Hold"])}
        {renderSection("Plating", "plating", ["On Plating", "Off Plating", "Incomplete Plating", "AA Changes Plating", "PE Changes Plating", "Plating On Hold"])}
      </Scroll>
    </Wrapper>
  );
};

export default PrepressTicket;

































// import React from "react";
// import ProcessSection from "./TimeTracker/ProcessSection";
// import useOperations from "../../../hooks/useOperations";
// import { duration } from "../../../utilities/time";
// import { Wrapper, Scroll, Flex, Flexed, Input, Textauto, Selectbox } from "../../../utilities/Shared";


// const PrepressTicket = ({ job, forms }) => {
//   const { mappedForms, changeTime, changeStatus } = useOperations(job, forms);

//   const sections = ["prepress", "proofing", "plating"];

//   return (
//     <Wrapper style={{ height: "70vh", position: "relative", color: "black" }}>
//       <Scroll height="100%">
//         {sections.map((section) => (
//           <div
//             key={section}
//             style={{
//               border: "1px solid black",
//               padding: "10px",
//               marginBottom: "20px",
//             }}
//           >
//             <Flexed>
//               <Flex
//                 fontSize="calc(1.3rem + .2vw)"
//                 fontWeight="bold"
//                 style={{ textDecoration: "underline" }}
//                 padding="5px"
//                 bgColor="var(--plsBlue)"
//                 color="white"
//               >
//                 {section.charAt(0).toUpperCase() + section.slice(1)}
//               </Flex>
//             </Flexed>

//             {/* Section Header Row */}
//             <Flexed padding="5px 0px 10px 0px">
//               <Flex style={{ textDecoration: "underline" }} fontSize="calc(1.1rem + .2vw)">
//                 Form:
//               </Flex>
//               <Flex flex="4">
//                 <Flexed>
//                   <Flex
//                     style={{ textDecoration: "underline" }}
//                     fontSize="calc(1.1rem + .2vw)"
//                     minWidth="20%"
//                   >
//                     Start
//                   </Flex>
//                   <Flex
//                     style={{ textDecoration: "underline" }}
//                     fontSize="calc(1.1rem + .2vw)"
//                     minWidth="20%"
//                   >
//                     Finish / Incomplete
//                   </Flex>
//                   <Flex
//                     flex=".5"
//                     style={{ textDecoration: "underline" }}
//                     fontSize="calc(1.1rem + .2vw)"
//                   >
//                     Actual
//                   </Flex>
//                 </Flexed>
//               </Flex>
//               <Flex
//                 flex=".5"
//                 style={{ textDecoration: "underline" }}
//                 fontSize="calc(1.1rem + .2vw)"
//               >
//                 Estimated
//               </Flex>
//               <Flex style={{ textDecoration: "underline" }} fontSize="calc(1.1rem + .2vw)">
//                 Status Change
//               </Flex>
//             </Flexed>

//             {/* Forms */}
//             {mappedForms.map((form) => {
//               const sessions = form.sessions.filter((s) => s.type === section);
//               return (
//                 <div key={form.id}>
//                   {sessions.map((s, index) => (
//                     <Flexed
//                       key={s.id}
//                       padding="4px 0px"
//                       borderBottom="1px solid grey"
//                       margin="0px 0px 15px 0px"
//                     >
//                       <Flex fontSize="calc(.9rem + .2vw)" top="8px">
//                         {form.name}
//                       </Flex>

//                       <Flex flex="4">
//                         {/* Start Time */}
//                         <Flex minWidth="20%">
//                           <input
//                             type="datetime-local"
//                             value={s.time}
//                             onChange={(e) => changeTime(s, e.target.value)}
//                             style={{ fontSize: "calc(1rem + .2vw)", width: "90%" }}
//                           />
//                         </Flex>

//                         {/* Finish / Incomplete (optional if available) */}
//                         <Flex minWidth="20%">
//                           {form.sessions[index + 1] && (
//                             <input
//                               type="datetime-local"
//                               value={form.sessions[index + 1].time}
//                               onChange={(e) =>
//                                 changeTime(form.sessions[index + 1], e.target.value)
//                               }
//                               style={{ fontSize: "calc(1rem + .2vw)", width: "90%" }}
//                             />
//                           )}
//                         </Flex>

//                         {/* Actual Duration */}
//                         <Flex flex=".5" fontSize="calc(1.2rem + .2vw)">
//                           {duration(s.time, new Date())}
//                         </Flex>
//                       </Flex>

//                       {/* Estimated Time (if available from impositions) */}
//                       <Flex flex=".5" fontSize="calc(1.2rem + .2vw)" style={{ top: "2.5px" }}>
//                         {form.impositions && form.impositions[0] ? (
//                           section === "prepress"
//                             ? `${form.impositions[0].presstime1}:${form.impositions[0].presstime2}`
//                             : section === "proofing"
//                             ? `${form.impositions[0].presstime1}:${form.impositions[0].presstime2}`
//                             : `${form.impositions[0].presstime1}:${form.impositions[0].presstime2}`
//                         ) : (
//                           "0:00"
//                         )}
//                       </Flex>

//                       {/* Status Dropdown */}
//                       <Flex style={{ textDecoration: "underline" }} fontSize="calc(1.1rem + .2vw)">
//                         <Selectbox
//                           onChange={(e) => changeStatus(form, e.target.value)}
//                           style={{ padding: "3px 0px" }}
//                         >
//                           <option value="">Select Status</option>
//                           <optgroup label="On Status">
//                             <option>On Prepress</option>
//                             <option>On Proofing</option>
//                             <option>On Plating</option>
//                           </optgroup>
//                           <optgroup label="Off Status">
//                             <option>Off Prepress</option>
//                             <option>Off Proofing</option>
//                             <option>Off Plating</option>
//                           </optgroup>
//                           <optgroup label="Changes">
//                             <option>Incomplete Prepress</option>
//                             <option>AA Changes Prepress</option>
//                             <option>PE Changes Prepress</option>
//                             <option>Prepress On Hold</option>
//                           </optgroup>
//                         </Selectbox>
//                       </Flex>
//                     </Flexed>
//                   ))}

//                   {/* Toner / Ink, Stock, Notes */}
//                   <Flexed borderBottom="1px solid grey" padding="5px 0">
//                     <Flex>
//                       {form.digital ? "Toner" : "Inks"} Used: <Input />
//                     </Flex>
//                     <Flex>Stock Used: <Input /></Flex>
//                     <Flex flex="5">
//                       Notes:<br />
//                       <Textauto minHeight="25px" />
//                     </Flex>
//                   </Flexed>
//                   <br />
//                 </div>
//               );
//             })}
//           </div>
//         ))}
//       </Scroll>
//     </Wrapper>
//   );
// };

// export default PrepressTicket;